<section class="blog single-blog section pt-1 pt-xs-0">
  <div class="container container-xs">
      <div class="row">
        <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12 animated fadeIn"  >
        </div>

        <div class="col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12   burbujalineal  animated fadeIn">


            <div class="row" *ngIf="loading || loadingBurbujas">
              <div class="col-12">
                  <div class="alert alert-info text-center">
                      <h4 class="alert-heading">Cargando</h4>
                      <i class="fa fa-sync fa-spin fa-3x"></i>
                      <p class="mb-0">Espera por favor...</p>
                  </div>
              </div>
            </div>


              <h4 class="tit">{{titulo}}</h4>

              <form autocomplete="off" [formGroup]="formu" (ngSubmit)="guardar()">
              <!--  <div class="form-group row">
                  <label class="col-2 col-form-label">Burbuja</label>
                  <div class="col">
                    <h6 class="yaseleccionado">{{burbuja}}</h6>
                  </div>
                </div>-->
                <div class="form-group row">
                  <label class="col-sm-12 col-md-12 col-form-label">Burbuja a asociar al tema</label>
                  <div class="col">
                    <select class="form-control form-select" formControlName="burbuja" id="burbuja" (change)="cambiarBurbuja($event)" [attr.disabled]="isAdmin ? null : ''" >
                      <option value="" disabled>Selecciona la burbuja</option>
                      <option *ngFor="let burbuja of burbujas" [value]="burbuja.id">{{burbuja.descripcion}}</option>
                    </select>
                   <small *ngIf="burbujaNoValida" class="text-danger">
                      Por favor selecciona la burbuja
                    </small>
                  </div>
                </div>


                  <div class="form-group row">
                    <label class="col-sm-12 col-md-12 col-form-label">Descripción</label>
                    <div class="col">
                      <input
                      class="form-control editainput"
                        type="text"
                        placeholder="Descripción"
                        formControlName="descripcion"
                        maxlength="250"
                      />
                      <small *ngIf="descripcionNoValida" class="text-danger">
                        Por favor ingresa la descripción del tema
                      </small>
                    </div>
                  </div>



                <div class="form-group row">
                  <label class="col-sm-12 col-md-12 col-form-label">&nbsp;</label>
                  <div class="input-group col">
                    <button type="button" (click)="volver()" class="btn editar mr-3 mt-3 btn-danger">
                      <i class="fas fa-undo-alt"></i> Cancelar
                    </button>&nbsp;
                    <button type="submit" class="btn btn-success guardar mr-3 mt-3">
                      <i class="fa fa-save"></i> Guardar
                    </button>
                    &nbsp;

                  </div>
                </div>
              </form>

          </div>



          <div class="col-md-10 offset-md-1 col-lg-2 offset-lg-0">
              <div class="sidebar">
                  <!-- Search Widget -->
                  <div class="widget search p-0">

                  </div>
                  <div class="widget related-store">
                    <!-- Widget Header -->

                </div>
                  <!-- Category Widget -->
                  <div class="widget category">
                      <!-- Widget Header -->

                  </div>
                  <!-- Store Widget -->
              </div>
          </div>
      </div>
  </div>
</section>

